import { NEW_SLA_FORMAT } from '@atlassian/jira-servicedesk-sla-panel/src/common/constants';
import type { Metric } from '../../common/types';

export const newMetric: Metric = {
	name: '',
	config: {
		definition: {
			start: [],
			pause: [],
			stop: [],
			inconsistent: false,
		},
		goals: {
			default: {
				jqlQuery: '',
				duration: '',
				calendarId: undefined,
				defaultGoal: true,
				timeMetricId: -1,
			},
		},
		slaDisplayFormat: NEW_SLA_FORMAT,
	},
};
